import { getExtension } from "../main/global-controllers/turbo/core/url.js";
// Convert Blob to dataURL
export function blobToDataURL(blob) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = () => reject(reader.error);
        reader.onabort = () => reject(new Error("Read aborted"));
        reader.readAsDataURL(blob);
    });
}
export function mimeTypeFromURLOrDataURL(dataURLOrURL) {
    if (dataURLOrURL.startsWith("http")) {
        return `image/${getExtension(new URL(dataURLOrURL)).split(".")[1]}`;
    }
    return mimeTypeFromDataURL(dataURLOrURL);
}
/**
 * Get mime type from dataURL
 *
 * @param dataURL - The dataURL
 * @returns The mime type string
 */
export function mimeTypeFromDataURL(dataURL) {
    return dataURL.split(",")[0].match(/^data:([^;,]+)/)[1];
}
/**
 * Convert dataURL to Blob
 *
 * @param dataURL - The dataURL
 */
export function dataURLtoBlob(dataURL) {
    const mime = mimeTypeFromDataURL(dataURL);
    const byteString = atob(dataURL.split(",")[1]);
    let n = byteString.length;
    const u8arr = new Uint8Array(n);
    // eslint-disable-next-line no-plusplus
    while (n--) {
        u8arr[n] = byteString.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
}
//# sourceMappingURL=data_url.js.map